import React from "react";
import "../css/Driverrule.css";

const Driverrule = () => {
  return (
    <div className="container">
      <h1>운수종사자를 위한 5S 태도</h1>

      <div className="item">
        <h2>Sincere (진실된 마음)</h2>
        <p className="description">고객과의 소통 시 진실된 태도를 유지하라.</p>
        <p className="quote">
          "고객님, 진심으로 사과드립니다. 불편을 끼쳐드려 죄송합니다."
        </p>
      </div>

      <div className="item">
        <h2>Safety (안전 우선)</h2>
        <p className="description">
          안전은 항상 최우선이다. 모든 결정과 행동은 고객과 본인의 안전을
          고려한다.
        </p>
        <p className="quote">
          "항상 안전 운행을 준수하겠습니다. 고객님의 안전이 가장 중요합니다."
        </p>
      </div>

      <div className="item">
        <h2>Service (서비스 정신)</h2>
        <p className="description">
          고객의 필요를 먼저 파악하고, 최선을 다해 서비스하라.
        </p>
        <p className="quote">
          "고객님께 최고의 서비스를 제공하기 위해 노력하겠습니다."
        </p>
      </div>

      <div className="item">
        <h2>Smile (미소)</h2>
        <p className="description">
          항상 미소를 잃지 말고 긍정적인 태도를 유지하라.
        </p>
        <p className="quote">
          "고객님을 만나 뵙게 되어 기쁩니다. 좋은 하루 보내세요!"
        </p>
      </div>

      <div className="item">
        <h2>Speed (신속한 대응)</h2>
        <p className="description">고객의 문제나 요청에 신속하게 대응하라.</p>
        <p className="quote">
          "바로 처리하겠습니다. 3분 내로 조치를 취하겠습니다."
        </p>
      </div>
    </div>
  );
};

export default Driverrule;
